import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your job role?",
                choices: [
                    generateNewChoice("Individual Contributor"),
                    generateNewChoice("Team Lead"),
                    generateNewChoice("Manager"),
                    generateNewChoice("Senior Manager"),
                    generateNewChoice("Regional Manager"),
                    generateNewChoice("Vice President"),
                    generateNewChoice("Management / C-Level"),
                    generateNewChoice("Partner"),
                    generateNewChoice("Owner"),
                    generateNewChoice("Volunteer"),
                    generateNewChoice("Intern"),
                    generateNewChoice("Other"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What department do you work in?",
                choices: [
                    generateNewChoice("Accounting"),
                    generateNewChoice("Administrative"),
                    generateNewChoice("Customer Service"),
                    generateNewChoice("Marketing"),
                    generateNewChoice("Human Resources"),
                    generateNewChoice("Sales"),
                    generateNewChoice("Finance"),
                    generateNewChoice("Legal"),
                    generateNewChoice("IT"),
                    generateNewChoice("Engineering"),
                    generateNewChoice("Product"),
                    generateNewChoice("Research &amp; Development"),
                    generateNewChoice("International"),
                    generateNewChoice("Business Intelligence"),
                    generateNewChoice("Manufacturing"),
                    generateNewChoice("Public Relations"),
                    generateNewChoice("Other"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with my opportunities for professional growth.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am pleased with the career advancement opportunities available to me.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My organization is dedicated to my professional development.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the job-related training my organization offers.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied that I have the opportunities to apply my expertise.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the investment my organization makes in training.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am inspired to meet my goals at work.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I feel completely involved in my work.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I get excited about going to work.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am often so involved in my work that the day goes by very quickly.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am determined to give my best effort at work each day.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "When at work, I am completely focused on my job duties.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "In my organization, employees adapt quickly to difficult situations.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Employees here always keep going when the going gets tough.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Employees proactively identify future opportunities.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Employees in my organization take the initiative to help other employees when the need arises.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Employees here are willing to take on new tasks as needed.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Employees in my organization willingly accept change.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am satisfied with my overall compensation.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am compensated fairly relative to my local market.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Communication between senior leaders and employees is good in my organization.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am able to make decisions affecting my work.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Management within my organization recognizes strong job performance.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My supervisor and I have a good working relationship.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My coworkers and I have a good working relationship.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "Senior management and employees trust each other.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "Employees treat each other with respect.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am satisfied with my total benefits package.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the healthcare-related benefits offered by my organization.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the amount of paid leave offered by my organization.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the retirement plan offered by my organization.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I am satisfied with the workplace flexibility offered by my organization.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "My organization has a safe work environment.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am satisfied with my overall job security.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My organization's work positively impacts people's lives.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My organization operates in a socially responsible manner.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "My organization's fiscal well-being is stable.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "I understand how my work impacts the organization's business goals.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "My organization is dedicated to diversity and inclusiveness.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "I am satisfied with the culture of my workplace.",
                choices: [
                    generateNewChoice("Strongly Disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neutral/Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
        ],
    },
];
export const employeeEngagementSurveyTemplate = generateSurveyTemplate({
    name: "Employee Engagement Survey",
    pages,
});
